
import { defineComponent, PropType } from "vue";
import { IconMenu } from "@/components/Icon";

export default defineComponent({
  name: "MenuButton",
  components: {
    IconMenu
  },
  props: {
    label: {
      type: String,
      required: true,
      default: "Menu"
    },
    ariaHaspopup: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    },
    ariaControls: {
      type: String,
      required: true,
      default: ""
    },
    ariaExpanded: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  },
  data() {
    return {
      hasFocus: false,
      hasHover: false
    };
  },
  mounted() {
    const button = this.$refs.btn;
    if (button instanceof HTMLButtonElement) {
      button.addEventListener("focusin", this.setHasFocus);
      button.addEventListener("focusout", this.removeHasFocus);
      button.addEventListener("mouseenter", this.setHasHover);
      button.addEventListener("mouseleave", this.removeHasHover);
    }
  },
  unmounted() {
    const button = this.$refs.btn;
    if (button instanceof HTMLButtonElement) {
      button.removeEventListener("focusin", this.setHasFocus);
      button.removeEventListener("focusout", this.removeHasFocus);
      button.removeEventListener("mouseenter", this.setHasHover);
      button.removeEventListener("mouseleave", this.removeHasHover);
    }
  },
  methods: {
    setHasFocus() {
      this.hasFocus = true;
    },
    removeHasFocus() {
      this.hasFocus = false;
    },
    setHasHover() {
      this.hasHover = true;
    },
    removeHasHover() {
      this.hasHover = false;
    }
  }
});
